import Button from '@/components/Button';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import { Status } from '@/models/Status';
import ProductListStatusSelectBox from '@/modules/product/components/ProductListStatusSelectBox';
import ProductListTable from '@/modules/product/components/ProductListTable';
import { ProductListAddPath } from '@/modules/product/paths';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { RectangleStackIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/solid';
import { useSearchParams } from 'react-router-dom';

const isStatus = (value: string | null): value is Exclude<Status, 'UNKNOWN'> =>
  value === 'ACTIVE' || value === 'INACTIVE';

const ProductListList = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();
  const [searchParams, setSearchParams] = useSearchParams();

  const statusParam = searchParams.get('status');
  const status = isStatus(statusParam) ? statusParam : undefined;

  const handleStatusChange = (nextStatus?: { id: string } | null) => {
    const params = new URLSearchParams(searchParams);
    params.delete('page');

    if (nextStatus?.id) {
      params.set('status', nextStatus.id);
    } else {
      params.delete('status');
    }

    setSearchParams(params);
  };

  const handleClearFilters = () => {
    setSearchQuery('');
    setSearchParams(new URLSearchParams());
  };

  return (
    <>
      <SettingsHeader title="Product Lists" icon={<RectangleStackIcon className="w-6 h-6" />}>
        <Button
          to={ProductListAddPath}
          icon={<PlusIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Add Product List
        </Button>
      </SettingsHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end">
        <div className="sm:w-72">
          <ProductListStatusSelectBox value={status ?? null} onSelect={handleStatusChange} />
        </div>
      </div>

      <ProductListTable
        searchQuery={searchQuery}
        status={status}
        page={page}
        onChangePage={handlePageChange}
        onClearFilters={handleClearFilters}
      />
    </>
  );
};

export default ProductListList;
